module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP9"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.8.0.0.box.280.693.1055.124.q.90"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    attrs: {
      "id": "para.8.0.0.box.280.693.1055.124.q.90"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.8.1.0.box.270.1078.1163.1240.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.8.1.0.box.277.1078.1154.197.q.60"
    }
  }, [_vm._v("Many persons have helped in this work. Appreciation is expressed to living ex-governors, to Governor Dolph Briscoe, Jr., and to members of governors' families who have furnished information.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.1.box.278.1296.1155.590.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.1.1.0"
    }
  }), _vm._v("Acknowledgment of indebtedness for materials provided is due R. W. Norton Art Gallery (library), Shreveport, Louisiana; Shreve-Memorial Library, Shreveport; Texas State Library, Austin; and the Texas Collection, University of Texas Library, Austin. Very special thanks are due Miss Nell Cunningham, Louisiana State University in Shreveport Library, who secured rare source material through loans; Mrs. Elizabeth Wallace, Stephen F. Austin State University Library, Nacogdoches, for her generous assistance; and Mrs. Mary Newell Pape, Houston Public Library, Houston.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP9.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.8.1.2.box.270.1897.1161.421.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP9.w.1.2.0"
    }
  }), _vm._v("Gratitude is expressed to Dr. Joseph Milton Nance, historian, editor, and professor of history, Texas A & M University, for reading the manuscript and for his thoughtful suggestions, but who is in no way responsible for any errors or oversights; Mrs. Penny Claudis, typist par excellence; Mrs. Mary Martin McDowell, who offered constructive suggestions for smoothness of structure; Mrs. Carol J. Carefoot, Texas State Library, Austin, and Mrs. May"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PP10.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.9.1.0.box.271.391.1154.99.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP10"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PP10.w.1.0.0"
    }
  }), _vm._v("\nSchmidt, Austin Public Library, for assistance in securing photographs.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PP10.w.1.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PP10"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.9.1.0.box.271.391.1156.480.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PP10.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.9.1.1.box.271.501.1156.370.q.60"
    }
  }, [_vm._v("Acknowledgments for use of photographs of Jones, Davis, Throckmorton, Stevenson, Jester, and Preston Smith are due the Texas State Library, Austin; those of Moody, Allred, Daniel, Briscoe, and Connally were furnished by the subjects or members of their families; the others were furnished by the Chalberg Photo Collection, Austin-Travis County Collection, Austin Public Library.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA1.w.0.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.10.0.0.box.402.927.880.41.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA1.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "108%",
      "text-indent": "0",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.10.0.0.box.402.927.880.41.q.80"
    }
  }, [_vm._v("THE GOVERNORS OF TEXAS")])])]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA2.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96cb8134","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0005.vue
// module id = 57
// module chunks = 0